import classNames from "classnames";
import expandableAmountRowStyles from "./ExpandableAmountRow.module.css";
import baseAmountRowStyles from "./AmountRowBase.module.css";
import { type PropsWithChildren, type JSX } from "react";
import { ValueWithCurrency } from "../ValueWithCurrency";

type ExpandableAmountRowProps = {
  id?: string;
  label: string;
  value?: number;
} & PropsWithChildren;

const ExpandableAmountRow = (props: ExpandableAmountRowProps): JSX.Element => {
  const { children, label, value, id } = props;

  const rowClasses = classNames(
    expandableAmountRowStyles.expandableAmountRow,
    baseAmountRowStyles.amountRow,
    baseAmountRowStyles.mainRow,
  );

  return (
    <tr className={rowClasses}>
      <td>
        <details>
          <summary id={id}>{label}</summary>
          <div className={classNames(expandableAmountRowStyles.expandedContent)}>{children}</div>
        </details>
      </td>
      <td className={baseAmountRowStyles.amount}>
        <ValueWithCurrency value={value!} />
      </td>
    </tr>
  );
};

export { ExpandableAmountRow };
